import produce from 'immer';

import {
  NOTICE_FORM_SECTION_CREATE_FAILURE,
  NOTICE_FORM_SECTION_EDIT_FAILURE,
  NOTICE_FORM_SECTION_EDIT_SUCCESS,
  NOTICE_FORM_SECTION_FETCH_FAILURE,
  NOTICE_FORM_SECTION_FETCH_SUCCESS,
  NOTICE_FORM_SECTION_LIST_FETCH_FAILURE,
  NOTICE_FORM_SECTION_LIST_FETCH_SUCCESS,
} from '@actions/noticeFormSection';

const initialState: INoticeFormSectionStore = {
  currentNoticeFormSection: null,
  noticeFormSections: null,
  error: null,
};

export default (state: INoticeFormSectionStore = initialState, action: any) =>
  produce(state, (draftState: INoticeFormSectionStore) => {
    switch (action.type) {
      case NOTICE_FORM_SECTION_EDIT_SUCCESS:
      case NOTICE_FORM_SECTION_FETCH_SUCCESS:
        draftState.currentNoticeFormSection = action.response;
        draftState.error = null;

        return;

      case NOTICE_FORM_SECTION_FETCH_FAILURE:
        draftState.currentNoticeFormSection = null;
        draftState.error = action.error;

        return;

      case NOTICE_FORM_SECTION_EDIT_FAILURE:
      case NOTICE_FORM_SECTION_CREATE_FAILURE:
        draftState.error = action.error;

        return;

      case NOTICE_FORM_SECTION_LIST_FETCH_FAILURE:
        draftState.noticeFormSections = null;
        draftState.error = action.error;

        return;

      case NOTICE_FORM_SECTION_LIST_FETCH_SUCCESS:
        draftState.noticeFormSections = action.response;
        draftState.error = null;

        return;
    }
  });
